import { IMyCourse } from '@/interfaces/course';
import { IPaginationParams, IPaginationResponse } from '@/interfaces/pagination';

import { get } from './api';

export const searchApi = (params: Partial<IPaginationParams>) => {
  return get<IPaginationResponse<IMyCourse[]>>({
    url: '/learner/course/search',
    params: {
      ...params,
      size: 20
    }
  });
};
export default searchApi;
